import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-5">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-book-read-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">57漫画网</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              57漫画网致力于为广大漫画爱好者提供免费、高质量的在线漫画阅读服务。蜜桃少年漫画全集尽在57漫画网，畅享免费阅读体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-5">快捷导航</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200">网站首页</Link></li>
              <li><Link to="/category/shaonian" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200">漫画分类</Link></li>
              <li><Link to="/comic/mitao-shaonian" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200">蜜桃少年漫画</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-5">热门分类</h4>
            <ul className="space-y-3">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-5">联系我们</h4>
            <ul className="space-y-3 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-400"></i>
                </div>
                contact@57manhua.com
              </li>
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-customer-service-line text-primary-400"></i>
                </div>
                在线客服：工作日 9:00-18:00
              </li>
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-primary-400"></i>
                </div>
                中国·北京
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2026 57漫画网 版权所有 | 蜜桃少年漫画在线免费阅读
          </p>
          <div className="flex items-center gap-5 text-xs text-background-400">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}